/* eslint-disable react-hooks/exhaustive-deps */
import React, { FunctionComponent, useRef, useMemo } from 'react';
// @ts-ignore @TODO: add types for package
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import 'moment-timezone';
import { DealerForPriceMatrix } from './types';

const DEFAULT_TIMEZONE = 'America/New_York';

interface Props {
  dealer: DealerForPriceMatrix | undefined;
  value: string | undefined | null;
  onChange: (value: string | undefined) => void;
}

const ExpirationInput: FunctionComponent<Props> = ({
  dealer,
  value,
  onChange,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const datePickerRef = useRef<any>(null);

  const currentTime = useMemo(
    () => moment().tz(dealer?.timezone || DEFAULT_TIMEZONE),
    [],
  );
  const valueMoment = useMemo(
    () => moment(value || undefined).tz(dealer?.timezone || DEFAULT_TIMEZONE),
    [value, dealer?.timezone],
  );
  const isExpired = useMemo(
    () => valueMoment.isBefore(currentTime),
    [valueMoment, currentTime],
  );

  return (
    <div className={`datepicker-container ${isExpired ? 'expired' : ''}`}>
      <DateRangePicker
        ref={datePickerRef}
        singleDatePicker
        minDate={currentTime}
        startDate={valueMoment}
        endDate={valueMoment}
        onApply={(e: unknown, { startDate }: { startDate: string }) => {
          onChange(
            moment
              .tz(startDate, dealer?.timezone || DEFAULT_TIMEZONE)
              .endOf('day')
              .toISOString(),
          );
        }}
      >
        <div className="datepicker">
          <div className="datepicker-icon ">
            <i className="glyphicon glyphicon-calendar" />
          </div>
          {value && (
            <div className="datepicker-display">
              {valueMoment.format('MM/DD/YYYY')}
            </div>
          )}
        </div>
      </DateRangePicker>
      {value && (
        <div
          className="datepicker-clear"
          title="Clear"
          onClick={() => {
            datePickerRef.current?.$picker
              ?.data('daterangepicker')
              ?.setStartDate(currentTime);
            datePickerRef.current?.$picker
              ?.data('daterangepicker')
              ?.setEndDate(currentTime);
            onChange(undefined);
          }}
        >
          ×
        </div>
      )}
    </div>
  );
};
export default ExpirationInput;
